import React from "react";
import { Col, Row } from "react-bootstrap";
import {
  SiVisualstudiocode,
  SiPostman,
  SiSlack,
  SiVercel,
  SiMacos,
  SiStackoverflow,
  SiWindows,
} from "react-icons/si";

function Toolstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <SiWindows />
        <div className="purple" style={{ fontSize: 15 }}>
          Windows
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiStackoverflow />
        <div className="purple" style={{ fontSize: 15 }}>
          StackOverflow
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVisualstudiocode />
        <div className="purple" style={{ fontSize: 15 }}>
          Visual Studio Code
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiPostman />
        <div className="purple" style={{ fontSize: 15 }}>
          PostMan
        </div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <SiVercel />
        <div className="purple" style={{ fontSize: 15 }}>
          Vercel
        </div>
      </Col>
    </Row>
  );
}

export default Toolstack;
